import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SeoPageService } from '@seo/feature';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-subtitle',
  templateUrl: './subtitle.component.html',
  styleUrls: ['./subtitle.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdSubtitleComponent {
  subtitle$: Observable<string | null> = this.seoPageService.getSeoPage().pipe(
    map((seo) => {
      if (!seo || !seo.subTitle) {
        return null;
      }

      return seo.subTitle;
    }),
  );

  loading$: Observable<boolean> = this.seoPageService.isLoading();

  constructor(private seoPageService: SeoPageService) {}
}
